// 거래소 관련 상수값
export const EXCHANGE_FEE_RATES = {
    'UPBIT': 0.0005,
    'BITHUMB': 0.0004,
    'BINANCEF': 0.00045,
    'BYBIT': 0.00025
};

// 거래소 이름
export const EXCHANGES = {
    KOREA: ['UPBIT', 'BITHUMB'],
    FUTURE: ['BINANCEF', 'BYBIT']
};
